import * as React from "react";
function SvgLiveHelp(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.2 15.1"
      ref={svgRef}
      {...props}
    >
      <path d="M11.5.1c1 0 1.7.8 1.7 1.8v12.2c0 .4-.2.7-.5.9-.1.1-.3.1-.4.1-.2 0-.4-.1-.7-.2l-2.7-1.6H1.7c-1 0-1.7-.8-1.7-1.8V1.8C0 .8.7.1 1.7 0h9.8v.1zm-.1 1.8H1.8v9.5h7.4c.2 0 .4.1.5.2l1.6 1v-1.2l.1-9.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLiveHelp);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
